// 退出登录
const logoutMixin = {
  data() {
    return {}
  },
  created() {},
  mounted() {},
  computed: {},
  components: {},
  methods: {
    // 退出登录
    async logout() {
      // 环信退出处理
      try {
        if (process.client && this.$WebIM && this.$WebIM.conn) {
          this.$WebIM.conn.close()
        }
      } catch (err) {
        console.error('环信退出错误', err)
      }

      try {
        const result = await this.$store.dispatch('logout')

        if (result) {
          this.checkInConsole()
          this.$message.success(this.$t('已退出登录'))
        } else {
          // 即使服务端退出失败，也要提示用户并清理本地状态
          this.$message.warning(this.$t('退出登录失败，已清理本地登录状态'))
          this.checkInConsole()
        }
      } catch (e) {
        console.error('退出登录错误:', e)

        // 强制清理本地状态
        this.$store.commit('LOGOUT')
        this.$store.commit('chat/RESET_ALL')

        this.$message.error(this.$t('退出登录异常，已清理本地状态'))
        this.checkInConsole()
      }
    },
    /**
     * @description: 检测是否在会员中心页面, 在的话跳转到首页
     * @param {*}
     * @return {*}
     */
    checkInConsole() {
      console.log('process.env.RELEASE', process.env.RELEASE)
      // 如果是本地
      if (process.env.NODE_ENV === 'development') {
        window.location.href = 'http://localhost:3000'
        return
      } else {
        window.location.href = process.env.RELEASE === 'stable' ? 'https://www.yzdli.com' : 'http://beta.yunhzh.com'
      }
    },
  },
}
export { logoutMixin }
